export const SMALL_IMAGE = 'small-image';
export const MEDIUM_IMAGE = 'medium-image';
export const LARGE_IMAGE = 'large-image';
export const UNAVAILABLE_IMAGE_RESOLUTION = 'unavailable';
export const USAGE_EDITORIAL = 'editorial';
export const NO_RELEASES = 'no-release';
export const YES_RELEASES = 'yes-release';

export const AI_TERMS_STATUS_ACCEPTED = 'accepted';
export const AI_TERMS_STATUS_REQUIRED = 'required';
export const AI_TERMS_STATUS_NOT_REQUIRED = 'not-required';

export const PAGE_MODE_NEW = 'new';
export const PAGE_MODE_EDIT = 'edit';
export const MAX_KEYWORDS = 70;
export const MAX_CATEGORIES = 3;
export const DEFAULT_PRODUCT_LISTING_PRICE = 150.0;

const UPLOAD = 'upload';
const TAGGING = 'tagging';
const PRODUCT_DETAILS = 'product-details';
export const WIZARD_TABS = { UPLOAD, TAGGING, PRODUCT_DETAILS };
export const WIZARD_TABS_LIST = [UPLOAD, TAGGING, PRODUCT_DETAILS];

export const BULK_UPLOAD_TEMPLATE_LINK =
  'https://docs.google.com/spreadsheets/d/1dTP5t2BMBMeHL3J4ipuCZeSYafAPSXysGPu6OHpDSyI/edit?usp=drive_link';
